import React from "react";

const STATUS_VISUALS = {
  // Figma's Active treatment is a plain 12px circle in the same on-tertiary
  // container tone as its label. Keep it in CSS so a baked SVG fill cannot
  // drift from the text token.
  active: { tone: "active", marker: "css" },
  neutral: { icon: "/icons/medical-institution/neutral_badge.svg", tone: "neutral" },
  critical: { icon: "/icons/medical-institution/revoked_badge.svg", tone: "critical" },
  nonactive: { icon: "/icons/medical-institution/neutral_badge.svg", tone: "nonactive" },
};

export function institutionLifecycleVisual(status) {
  const normalized = String(status || "draft").toLowerCase();
  if (normalized === "active") return STATUS_VISUALS.active;
  if (["revoked", "removed", "blocked", "deleted"].includes(normalized)) return STATUS_VISUALS.critical;
  if (["invitation_not_sent", "invitation_pending", "draft", "provisional"].includes(normalized)) return STATUS_VISUALS.neutral;
  return STATUS_VISUALS.nonactive;
}

/**
 * Shared compact lifecycle treatment for Institution roster and relationship
 * states. The 20px pill and 12px artwork slot are intentionally independent:
 * SVG viewBoxes must never alter a list row's visual rhythm.
 */
export default function InstitutionLifecycleBadge({ status, label, className = "", classPrefix = "institutions-clinician-status" }) {
  const visual = institutionLifecycleVisual(status);
  return (
    <span className={`${classPrefix} ${classPrefix}--${visual.tone} text-label-medium ${className}`.trim()}>
      <span className={`${classPrefix}-marker`} aria-hidden="true">
        {visual.marker === "css" ? <span className={`${classPrefix}-marker-dot`} /> : <img src={visual.icon} alt="" className={`${classPrefix}-marker-icon`} />}
      </span>
      {label}
    </span>
  );
}
